import { render } from "./TituloMarketingNew.vue?vue&type=template&id=5011544f&scoped=true"
import script from "./TituloMarketingNew.vue?vue&type=script&lang=js"
export * from "./TituloMarketingNew.vue?vue&type=script&lang=js"

import "./TituloMarketingNew.vue?vue&type=style&index=0&id=5011544f&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5011544f"]])

export default __exports__